'use client'

import React, { CSSProperties } from 'react'
import type { LottieBlock as BlockProps } from '@/payload-types'
import dynamic from 'next/dynamic'
import { getScreenStyle } from '@/blocks/BlockStyle'
import { useTailwindScreen } from '@/lib/client/hooks/useTailwindScreen'

export const LottieBlock: React.FC<BlockProps> = ({ source, style: responsiveStyle }) => {
  const screen = useTailwindScreen()
  if (!source) return null
  const Lottie = dynamic(() => import('react-lottie'), { ssr: false })
  const style = getScreenStyle(responsiveStyle ?? {}, screen ?? 'sm') as CSSProperties
  return (
    <Lottie
      style={style}
      options={{
        loop: true,
        autoplay: true,
        animationData: JSON.parse(source),
      }}
    />
  )
}
